export function isCSSUrl(url) {
  return /\.css(\?.*)?$/.test(url);
}